interface Props {
  onLogIn: () => void;
}

const SessionExpiredModal = ({ onLogIn }: Props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4 text-center">
        <h2 className="text-lg font-semibold text-neutral-800 mb-2">Session expired</h2>
        <p className="text-sm text-neutral-500 mb-6">
          Your session has expired. Please log in again to continue.
        </p>
        <button
          onClick={onLogIn}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 rounded-md transition-colors"
        >
          Log in again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
